<template>
<div class="hot-page" v-loading="pageLoading">
<audio ref="audio" autoplay="autoplay"  @ended.stop="audioEnded" v-if="info && info.sound_url" :src="info.sound_url" controls @loadedmetadata="loadedmetadata" @timeupdate.stop="updateProgress"></audio>
  <van-nav-bar ref="nav" :border="false" @click-left="back" placeholder :fixed="true" title="锦囊详情">
    <template #left>
      <van-icon size="20px" name="arrow-left" color="#333" />
    </template>
  </van-nav-bar>
  <div class="hot-video">
    <div class="video player" id="player"></div>

  </div>
 
  <div class="ideaHeader">
    <div class="title">{{info.name}}</div>
    <div class="auther">
      <img class="autherImg" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BB%84%2029%402x.png" alt="" mode="aspectFill"/>
      <div class="autherNm">
        托育高研院官方账号
        <div class="time">
          {{info.updated_at}}
        </div>
      </div>
      {{info.pv_count}}人看过
    </div>
  </div>
  <div class="ideaAudio" v-if="info.sound_url">
      <img class="logo" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%205%402x.png"/>
      <div class="process">
        {{currentTm}}
        <div class="processImg">
          <div class="red" :style="{width:redWidth+'%'}" >
            <img :src="redImg" mode="aspectFill"/>
          </div>
           <img :src="grayImg" class="gray"/>
        </div>
        {{totalTm}}
      </div>
      <img class="control" :src="isPlay ? playImg : pauseImg" @click="playAudio"/>
  </div>
  <div class="content">
      <div v-html="info.content">

      </div>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  computed: {
    partalName() {
      return this.$store.state.partal.name;
    },
  },
  data() {
    return {
      pageLoading:false,
      currentTm:'00:00',
      totalTm:'',
      isPlay:false,
      playImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%204%E5%A4%87%E4%BB%BD%202%403x.png',
      pauseImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%204%E5%A4%87%E4%BB%BD%403x.png',
      innerAudioContext:null,
      currentAudio:'',
      url:'http://music.163.com/song/media/outer/url?id=447925558.mp3',
      grayImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BB%84%203%403x.png',
      redImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BA%A2%E8%89%B2%403x.png',
      animalTimer:null,
      redWidth:0,
      autoplay:true,
      id:'',
      info:{}
    };
  },
  destroyed() {
    // for (var i = 0; i < this.list.length; i++) {
    //   let vid = this.list[i];
    //   this.players[vid] && this.players[vid].destroy();
    // }
  },
  async mounted() {
    this.pageLoading = true
    this.id = this.$route.query.id;
    let res = await this.$api({
      method: 'get',
      url: '/api/silkbag/detail',
      data: {
        id: this.id,
      }
    })
    if (res.code == 0) {
      this.addHistory(this.id);
      if(!res.data) {
        this.pageLoading = false
        return
      }
      res.data.updated_at = res.data.updated_at.slice(0,10)
      res.data.content = res.data.content.replace(/<img[^>]*>/gi, function (match, capture) {
                        return match.replace(/(<img[^>]*)(\/>)/gi, "$1style='max-width:100%;width:auto;height:auto;' $2")
                    })
      this.info = res.data
      this.palyVideo(this.info.video_url)
      this.pageLoading = false
    }
    
  },
  methods: {
    // 浏览记录
    async addHistory(id) {
        let res = await this.$api({
          method: 'get',
          url: "/api/silkbag/detail/click", 
          data: {
                  id: id,
          }
        });
    },
    // 播放视频
    async palyVideo(url){
      if (url) {
            this.player = new Aliplayer({
                id: 'player',
                width: "100%",
                height: "300px",
                source: url,
                cover: this.info.img_url,
                skinLayout: [{
                    name: "bigPlayButton",
                    align: "blabs",
                    x: 30,
                    y: 80
                  },
                  {
                    name: "H5Loading",
                    align: "cc",
                  },
                  {
                    name: "errorDisplay",
                    align: "tlabs",
                    x: 0,
                    y: 0
                  },
                  {
                    name: "infoDisplay"
                  },
                  {
                    name: "tooltip",
                    align: "blabs",
                    x: 0,
                    y: 56
                  },
                  {
                    name: "thumbnail"
                  },
                  {
                    name: "controlBar",
                    align: "blabs",
                    x: 0,
                    y: 0,
                    children: [{
                        name: "progress",
                        align: "blabs",
                        x: 0,
                        y: 44
                      },
                      {
                        name: "playButton",
                        align: "tl",
                        x: 15,
                        y: 12
                      },
                      {
                        name: "timeDisplay",
                        align: "tl",
                        x: 10,
                        y: 7
                      },
                      {
                        name: "fullScreenButton",
                        align: "tr",
                        x: 10,
                        y: 12
                      },
                      {
                        name: "subtitle",
                        align: "tr",
                        x: 15,
                        y: 12
                      },
                      {
                        name: "volume",
                        align: "tr",
                        x: 5,
                        y: 10
                      },
                    ],
                  },
                ],
              },
              function (player) {
                console.log("The player is created.");
              }
            );
          } else {
            // if (type == 'aliyun') {
            //   let vid = id;
            //   let res = await this.$api({
            //     url: "/api/video/play-auth/get",
            //     data: {
            //       video_id: vid,
            //     },
            //   });
            //   if (res.code == 0) {
            //     if (this.player) {
            //       this.player.dispose();
            //     }
            //     this.player = new Aliplayer({
            //         id: "player",
            //         width: "100%",
            //         height: "100%",
            //         vid: res.data.videoId,
            //         playauth: res.data.playAuth,
            //       },
            //       function (player) {
            //         console.log("The player is created.");
            //       }
            //     );
            //   }
            // } else {
            //   this.player = window.createCCH5Player({
            //     vid: id,
            //     siteid: "23EEB4513490D389",
            //     autoStart: true,
            //     playertype: 1,
            //     isShare: "false",
            //     banDrag: "false",
            //     width: "100%",
            //     height: "100%",
            //     loop: "true",
            //     showFullScreenBtn: "false",
            //     useX5Play: "true",
            //     isShowUrlBtn: "false",
            //     isShowMoreBtn: "false",
            //     objectFit: "cover", // contain 、 fill 、 cover
            //     parentNode: ".video",
            //   });
            // }
          }
    },
    back() {
      this.$router.go(-1);
    },
    // 音频初始化完成获取秒数
        loadedmetadata(event) {
            // this.progressBoxWidth = this.$refs.progressBox.offsetWidth
            // console.log('progressBoxWidth:',this.progressBoxWidth)
            console.log('录音时长：',event.target.duration,event)
            this.totalTm = this.transTime(event.target.duration,event)
            // this.$set(this.audioData,'duration',this.transTime(event.target.duration))
            this.$forceUpdate()
            
        },
        // 音频播放位置发生改变-进度条播放的事件
        updateProgress() {
            let audio = this.$refs.audio
            // let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
            let value = ((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100).toFixed(2)
            // this.$set(this.audioData,'currentTime',this.transTime(audio.currentTime))
            this.currentTm = this.transTime(audio.currentTime)
            this.$forceUpdate()
            // console.log('音频进度条改变：',this.percentBar)
            // this.progressWidth = Math.round(Math.floor(audio.currentTime) * this.progressBoxWidth / Math.floor(audio.duration))+'px'
        },
        // 播放结束的处理动作
        audioEnded() {
            console.log('播放结束')
            this.isPlay = false
            let audio = this.$refs.audio
            // audio.currentTime = 0
            audio.pause()
        },
        playAudio() {
            let audio = this.$refs.audio
            this.isPlay = !this.isPlay
            if(this.isPlay) {
                audio.play()
                this.animalTimer = setInterval(()=>{
                  this.redWidth = this.redWidth==100 ? 0 : this.redWidth+5
                },100)
            }else {
              clearInterval(this.animalTimer)
                audio.pause()
            }
        },
        
        // 点击进度条
        clickProgress(event) {
            this.progressBoxWidth = this.$refs.progressBox.offsetWidth
            console.log('progressBoxWidth:',this.progressBoxWidth)
            console.log('点击进度条：',event)
            var duration = this.$refs.audio.duration
            var currentTime = Math.floor(event.offsetX * duration / this.progressBoxWidth) 
            this.$refs.audio.currentTime = currentTime
            // console.log(currentTime,'---',this.$refs.audio.currentTime)
            // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
            // this.progressWidth = event.offsetX >= this.progressBoxWidth ? event.offsetX+'px' : this.progressBoxWidth+'px'
        },
        // 滑块移动
        progressMove(event) {
            console.log('滑块移动：',event)
            var duration = this.$refs.audio.duration
            // this.$set(this.audioData,'duration',this.transTime(duration))
            var currentTime = Math.floor((this.touchStartBarWidth+event.touches[0].clientX - this.touchStartX) * duration / this.progressBoxWidth)
            currentTime >= duration ? duration : currentTime
            this.$refs.audio.currentTime = currentTime
            // this.$set(this.audioData,'currentTime',this.transTime(currentTime))
        },
        // 滑块开始触摸
        touchstart(event) {
            console.log('滑块开始触摸:',event)
            this.touchStartX = event.touches[0].clientX
            this.touchStartBarWidth = this.$refs.progressBar.offsetWidth
        },
        // 将秒数转化成(分:秒)格式
        transTime(time) {
            let duration = parseInt(time)
            let minute = parseInt(duration / 60).toString().padStart(2, '0')
            let sec = (duration % 60).toString().padStart(2, '0')
            return `${minute}:${sec}`
        },
  },
  beforeDestroy(){
    clearInterval(this.animalTimer)
  }
};
</script>

<style>
audio {
    position: absolute;
    top: 0;
    display: block;
    height: 0;
    width: 0;
    opacity: 0;
}
.detail-page {
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.video-wrap {
  width: 750px;
  height: 400px;
  position: relative;
}

.detail-page .video {
  width: 100%;
  height: 100%;
  background: #000;
}

.cc_video {
  width: 100%;
  height: 440px !important;
  background: #000;
}

#videoPlayer {
  width: 100%;
  height: 400px;
  background: #000;
}

.detail-page .share {
  position: absolute;
  right: 0;
  top: 37px;
  width: 109px;
  height: 52px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px 0 0 27px;
  color: #ddd;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.detail-page .share img {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
.ideaHeader{
  width: 100vw;
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 17px solid #F5F5F5;
}
.ideaHeader .title{
  font-size: 34px;
  padding-bottom: 30px;
}
.ideaHeader .auther{
   display: flex;
   flex: 1;
   font-size: 26px;
   color: #666666;
}
.ideaHeader .auther .autherNm{
  flex: 1;
  font-size: 28px;
  color: #333333;
}
.ideaHeader .auther img{
  width: 60px;
  height: 60px;
  margin-right: 20px;
}
.ideaHeader .auther .time{
  font-size: 22px;
  margin-top: 8px;
  color: #666666;
}
.content{
  padding: 30px;
  background: #ffffff;
}
.ideaAudio{
  background: url(https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%207%402x.png);
  background-size: cover;
  width: 750px;
  height: 931px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ideaAudio .logo{
  width: 348px;
  height: 348px;
}
.ideaAudio .process{
  padding: 80px 0 108px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ideaAudio .control{
  width: 116px;
  height: 116px;
}
.process .processImg{
   width: 316px;
   height: 42px;
   position: relative;
   margin: 0 30px;
}
.process .processImg img{
  width: 316px;
  height: 42px;
}
.process .processImg .red{
  position: absolute;
  left: 0;
  top:0;
  overflow: hidden;
}
</style>
